import * as Components from 'components/system'
import {useScreen} from 'hooks/useScreen'
import {AppearanceProvider} from '../../providers/AppearanceProvider'
import {Applaying} from './views/Applying/Applying'
import {Confirming} from './views/Confirming/Confirming'

export const Footer = () => {
  const builderManager = AppearanceProvider.useManager()
  const screen = useScreen()

  return (
    <Components.Footer>
      <>
        {screen === 'desktop' && <Applaying />}
        {screen === 'mobile' && (
          <>
            {builderManager.mode === 'input' && <Confirming />}
            {builderManager.mode === 'preview' && <Applaying />}
          </>
        )}
      </>
    </Components.Footer>
  )
}
